export default __webpack_public_path__ + "static/media/resultadopreliminar012024.cfd2c9bc.pdf";